import { useQuery } from "@tanstack/react-query";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { api } from "api";

const REFETCH_INTERVAL = 1000 * 60; // 1 minute

export const NoSlotsChecker = ({ examDateId }: { examDateId?: number }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isSuccess } = useQuery({
    queryKey: ["examDetails", examDateId],
    queryFn: async () => {
      const result = await api.exams.getExamDate(examDateId!);
      return result.data;
    },
    refetchInterval: REFETCH_INTERVAL,
    enabled: !!examDateId,
  });

  const open =
    isSuccess &&
    data?.slotsLeft !== null &&
    data?.slotsLeft !== undefined &&
    data.slotsLeft <= 0;

  const handleClose = () => {
    navigate("/");
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t("common.sorry")}</DialogTitle>
      <DialogContent>
        <Alert severity="warning">{t("common.noSlotsLeft")}</Alert>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button variant="outlined" onClick={handleClose}>
          {t("common.ok")}
        </Button>
      </DialogActions>
      <Stack direction="row" sx={{ justifyContent: "center", gap: 2 }}></Stack>
    </Dialog>
  );
};
